var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 2.69489L15.4141 2.69488L15.4128 2.69335L13.5378 0.637687L13.5372 0.637138C13.3967 0.485306 13.2042 0.4 13 0.4H3C2.79633 0.4 2.60316 0.484933 2.46672 0.638146L0.592301 2.69317C0.592266 2.69321 0.592231 2.69325 0.592197 2.69328C0.468286 2.82851 0.4 2.99893 0.4 3.18555V14.875C0.4 15.2769 0.723092 15.6 1.125 15.6H14.875C15.2769 15.6 15.6 15.2769 15.6 14.875V3.18555C15.6 2.9991 15.5319 2.82947 15.4141 2.69489ZM5.5 5.4H5.4V5.5V6.75V6.85H5.5H10.5H10.6V6.75V5.5V5.4H10.5H5.5ZM3.31777 1.85H12.6822L13.6338 2.9H2.36621L3.31777 1.85ZM1.85 4.35H14.15V14.15H1.85V4.35Z",
    fill: "#3282B8",
    stroke: "#3282B8",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/BoxIcon.52669d44d9abf5eed83293b44ac40e74.svg";
export { ForwardRef as ReactComponent };